import React from "react";
import { Link } from "react-router-dom";
import { CompassMark } from "@/components/CompassMark";

export const ContactInvitation = () => {
  return (
    <section data-testid="home-contact-invitation" className="relative bg-ink-base py-24 md:py-36 border-t border-ink-line overflow-hidden">
      <div className="container-edge relative">
        <div className="max-w-3xl">
          <p className="eyebrow-gold mb-5">Contact</p>
          <h2 className="display-serif text-3xl md:text-5xl lg:text-6xl text-paper-primary leading-[1.05] tracking-[-0.015em] text-balance">
            Serious correspondence is welcome.
            <span className="block text-paper-tertiary mt-2">The rest can wait.</span>
          </h2>
          <p className="mt-8 max-w-xl font-serif text-lg text-paper-secondary leading-relaxed text-pretty">
            Coaching, speaking, collaboration, media, or a thoughtful letter, there is one channel and it is read.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
            <Link to="/contact" data-testid="home-contact-cta" className="btn-quiet inline-flex">
              <span>Open the channel</span>
              <span>→</span>
            </Link>
            <Link to="/coaching" data-testid="home-coaching-link" className="btn-arrow">
              <span>Coaching</span>
              <span className="arrow">→</span>
            </Link>
            <Link to="/speaking" data-testid="home-speaking-link" className="btn-arrow">
              <span>Speaking</span>
              <span className="arrow">→</span>
            </Link>
          </div>
        </div>

        <CompassMark
          size={420}
          opacity={0.04}
          className="absolute -right-20 -bottom-20 hidden md:block pointer-events-none"
          alt=""
        />
      </div>
    </section>
  );
};

export default ContactInvitation;
